import { render, staticRenderFns } from "./cate-module.vue?vue&type=template&id=04ee6da4&scoped=true&"
import script from "./cate-module.vue?vue&type=script&lang=js&"
export * from "./cate-module.vue?vue&type=script&lang=js&"
import style0 from "./cate-module.vue?vue&type=style&index=0&id=04ee6da4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ee6da4",
  null
  
)

export default component.exports